import whyChooseMascot from "../assets/whychooosemascot.png";
import { useInView } from "../hooks/useInView";

const HowItWorks = () => {
  const { ref, isInView } = useInView({ threshold: 0.3, triggerOnce: false });

  const steps = [
    {
      number: "1",
      title: "Apply Online",
      description: "Fill A Short Form It Takes Less Than 2 Minutes."
    },
    {
      number: "2",
      title: "Get Instant Approval",
      description: "We Quickly Assess Your Eligibility Using Digital Checks."
    },
    {
      number: "3",
      title: "Receive Money Instantly",
      description: "Approved Funds Are Credited Directly To Your Bank Account."
    }
  ];

  return (
    <section ref={ref} className="w-full py-10 md:py-12 lg:py-15 bg-[#EFFFFD]">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        {/* Header */}
        <h1 className={`text-4xl md:text-5xl lg:text-6xl font-bold text-[#2C3E50] mb-12 md:mb-16 text-center font-['Inter'] pt-8 md:pt-12 transition-all duration-700 ${
          isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          How It Works
        </h1>
        
        {/* Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* Left Side - Mascot Image */}
          <div className={`flex justify-center items-center transition-all duration-1000 ${
            isInView ? 'opacity-100 scale-100 rotate-0' : 'opacity-0 scale-75 -rotate-12'
          }`}>
            <img 
              src={whyChooseMascot} 
              alt="How It Works Mascot" 
              className="max-w-full h-auto animate-float" 
            />
          </div>
          
          {/* Right Side - Steps */}
          <div className="flex flex-col gap-8 md:gap-10">
            {steps.map((step, index) => (
              <div 
                key={index} 
                className={`flex gap-2 md:gap-4 items-start transition-all ease-out ${
                  isInView ? 'opacity-100 translate-y-0 duration-700' : 'opacity-0 translate-y-8 duration-200'
                }`}
                // Reveal 1 → 2 → 3 in sequence; reset instantly when scrolled away so it replays
                style={{ transitionDelay: isInView ? `${300 + index * 600}ms` : '0ms' }}
              >
                {/* Step Number Circle */}
                <div className="flex-shrink-0 self-stretch flex flex-col items-center">
                  <div className="w-10 h-10 md:w-10 md:h-10 lg:w-20 lg:h-20 rounded-full bg-gradient-to-br from-[#21A6B5] to-[#3D4A7C] flex items-center justify-center text-white text-2xl md:text-3xl lg:text-4xl font-bold font-['Inter'] relative shadow-lg hover:scale-110 transition-transform duration-300 animate-pulse-glow">
                    {step.number}
                  </div>
                  {/* Dotted Line Connector - runs through the row gap to the next circle */}
                  {index < steps.length - 1 && (
                    <div
                      className={`flex-1 -mb-8 md:-mb-10 border-l-2 border-dashed border-[#21A6B5] origin-top transition-transform ease-out ${
                        isInView ? 'scale-y-100 duration-500' : 'scale-y-0 duration-0'
                      }`}
                      style={{ transitionDelay: isInView ? `${300 + index * 600 + 400}ms` : '0ms' }}
                    ></div>
                  )}
                </div>
                
                {/* Step Content */}
                <div className="flex-1 bg-white rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-105">
                  <h3 className="text-xl md:text-2xl lg:text-3xl font-bold text-[#2C3E50] mb-3 md:mb-4 font-['Inter']">
                    {step.title}
                  </h3>
                  <p className="text-base md:text-lg lg:text-xl text-gray-700 leading-relaxed font-['Inter']">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
